// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{empId}/work-shifts",
  Create: "/pyr/employees/work-shifts",
  Update: "/pyr/employees/{empId}/work-shifts",
};
